var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgReport = function SvgReport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-175 -397) translate(8 200) translate(167 197)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    d: "M10.125 1.516c-.696-.402-1.554-.402-2.25 0L3.081 4.283c-.696.402-1.125 1.145-1.125 1.95v5.535c0 .804.429 1.547 1.125 1.949l4.794 2.767c.348.201.737.302 1.125.302s.777-.1 1.125-.302l4.794-2.767c.348-.201.63-.488.824-.824.194-.336.301-.723.301-1.125V6.232c0-.402-.107-.789-.301-1.125-.194-.336-.476-.623-.824-.824l-4.794-2.767z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 1,
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A6A6A",
    d: "M7.816 5h2.368c.23 0 .417.187.417.417 0 .02-.002.04-.005.06l-.71 4.834c-.03.204-.206.356-.413.356h-.946c-.207 0-.383-.152-.413-.356l-.71-4.834c-.034-.227.123-.44.351-.473.02-.003.04-.004.06-.004z"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Report.0fe6ac7b.svg";
export { ForwardRef as ReactComponent };